export default __webpack_public_path__ + "static/mobile-exchange-76d2972d07ff2e308359ad83fd3a0b01.png";